<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent max-width="1500">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <span class="subheadline">Informe/Auditoria Club Nuevo</span>
          <v-layout row wrap class="item-group">
            <v-flex>
              <v-autocomplete
                v-model="report"
                label="Tipo de Informe a Crear"
                required
                :error-messages="getRequiredErrors('report')"
                :items="reports"
                item-text="description"
                item-value="pk"
              ></v-autocomplete>
            <!--  <v-text-field
                v-model="descripcion"
                label="Nombre de Informe"
                placeholder=""
                required
                :error-messages="getRequiredErrors('descripcion')"
                @input="onDescriptionChange"
              ></v-text-field>-->
                        <v-autocomplete v-model="categoriasSeleccionadas" label="Categoría" required :error-messages="getRequiredErrors('categoriasSeleccionadas')"
                        multiple :items="categorias" item-text="description" item-value="id">
                 <v-list-tile slot="prepend-item" ripple @click="selectAllCategories()">
                <v-list-tile-action></v-list-tile-action>
                <v-list-tile-title>Seleccionar todas</v-list-tile-title>
              </v-list-tile>
              <v-divider slot="prepend-item"></v-divider>
                </v-autocomplete>
                        <v-autocomplete v-model="clubesSeleccionados" label="Clubes" required :error-messages="getRequiredErrors('clubesSeleccionados')"
                        multiple :items="clubes" item-text="nombre" item-value="pk">
                 <v-list-tile slot="prepend-item" ripple @click="selectAll()">
                <v-list-tile-action></v-list-tile-action>
                <v-list-tile-title>Seleccionar todos</v-list-tile-title>
              </v-list-tile>
              <v-divider slot="prepend-item"></v-divider>
                </v-autocomplete>
              <DatePickerForm v-model="fechaInicioCarga" label="Fecha de Inicio de Carga" showLabel
                :error-messages="getRequiredErrors('fechaInicioCarga')"></DatePickerForm>
                <DatePickerForm v-if="requiresExpiration" v-model="fechaVencimiento" label="Fecha de Vencimiento" showLabel
                :error-messages="getRequiredErrors('fechaVencimiento')"></DatePickerForm>

            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-btn color="primary" @click="closeDialog">Volver</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submit">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../../mixins/createEntityMixin'
import DatePickerForm from '../../../../common/ui/DatePickerForm'

export default {
  mixins: [validationMixin, createEntityMixin],

  validations: {
    report: { required },
    // descripcion: { required },
    clubesSeleccionados: { required },
    fechaInicioCarga: { required },
    fechaVencimiento: {
      required: requiredIf(function () {
        return this.requiresExpiration
      })
    },
    categoriasSeleccionadas: { required }
  },

  components: { DatePickerForm },

  data () {
    return {
      dialog: false,
      createPath: 'informe-auditoria/create-to-club',
      isEditing: false,
      definicionPresentacion: null,
      reports: [],
      report: null,
      descripcion: null,
      clubes: [],
      club: null,
      fechaInicioCarga: null,
      fechaVencimiento: null,
      clubesSeleccionados: [],
      categorias: [],
      categoriasSeleccionadas: []
    }
  },
  methods: {
    selectAll () {
      if (this.clubesSeleccionados.length === this.clubes.length) {
        this.clubesSeleccionados = []
      } else {
        this.clubesSeleccionados = this.clubes.map(x => x.pk)
      }
      this.$forceUpdate()
    },
    fetchDefiniciones () {
      this.axios
        .get('informe-auditoria/reportes-para-clubs', {
          params: {
            modulo: 1
          }
        })
        .then(response => {
          this.reports = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    isValidForm () {
      return !this.$v.$invalid
    },
    getPayload () {
      return {
        report: this.report,
        description: this.descripcion,
        clubes: this.clubesSeleccionados,
        type: 1,
        fechaCarga: this.fechaInicioCarga,
        fechaVencimiento: this.requiresExpiration ? this.fechaVencimiento : null
      }
    },
    showDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },
    onDescriptionChange (event) {
      this.descripcion = event
    },
    fetchClubes (categoriasSeleccionadas) {
      this.clubes = []
      if (!categoriasSeleccionadas || categoriasSeleccionadas.length === 0) {
        this.clubes = []
        return
      }

      const categoriaIds = categoriasSeleccionadas.join(',')
      this.axios
        .get(`clubes?categories=${categoriaIds}`)
        .then(response => {
          this.clubes = response.data
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    postSuccessfulSubmit () {
      this.goBack()
      this.saving = false
    },
    goBack () {
      this.goBackConfirmed = true
      this.$router.go()
    },
    fetchCategorias () {
      this.axios
        .get('informe-auditoria/categorias')
        .then(response => {
          this.categorias = response.data
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    selectAllCategories () {
      if (this.categoriasSeleccionadas.length === this.categorias.length) {
        this.categoriasSeleccionadas = []
      } else {
        this.categoriasSeleccionadas = this.categorias.map(x => x.id)
      }
      this.$forceUpdate()
    }
  },
  computed: {
    selectedReport () {
      return this.reports.find(r => r.pk === this.report) || {}
    },
    requiresExpiration () {
      return this.selectedReport.needExpiration
    }
  },
  created () {
    this.fetchDefiniciones()
    this.fetchClubes()
    this.fetchCategorias()
  },
  watch: {
    categoriasSeleccionadas (newCategorias, oldCategorias) {
      this.fetchClubes(newCategorias)
    }
  }
}
</script>

<style>
.subheadline {
  color: lightslategray;
  font-size: 1.6em;
  color: rgb(60, 145, 197);
  padding-top: 1.5em;
  margin-top: 2em;
}
</style>
